<template>
	<div class="content">
		<h3>包装关系文件查询</h3>
		<div class="item">
			<el-form ref="form" inline  :model="form" label-width="80px">				
				<el-form-item label=" " style="width:100%">
                    <el-radio-group v-model="form.radio" style="display: inline-flex;">
                        <el-radio :label="1">从文件查询</el-radio>
                        <el-radio :label="2">从生产任务查询</el-radio>
                    </el-radio-group>
				</el-form-item>
                <el-form-item label="时间类型">
					<el-select v-model="form.isActive" clearable placeholder="请选择">
						<el-option
						v-for="item in state"
						:key="item.value"
						:label="item.lable"
						:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="开始时间">
					<el-date-picker
						v-model="form.factoryName" value-format="yyyy-MM-dd"
						type="date"
						placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
                <el-form-item label="结束时间">
					<el-date-picker
						v-model="form.factoryName" value-format="yyyy-MM-dd"
						type="date"
						placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
                
                <el-form-item label="处理状态">
					<el-select v-model="form.isActive" clearable placeholder="请选择">
						<el-option
						v-for="item in state"
						:key="item.value"
						:label="item.lable"
						:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
                
                <el-form-item label="文件名">
					<el-input v-model="form.factoryName"></el-input>
				</el-form-item>
			</el-form>
			<div class="btn">
				<el-button type="primary"  @click="SelFactory">查 询</el-button>
				<el-button type="warning">重 置</el-button>
			</div>
		</div>
		<div class="item">
			<el-table :data="tableData" border>
				<el-table-column align="center" prop="Address" label="文件名"></el-table-column>
                <el-table-column align="center" prop="Address" label="上传时间"></el-table-column>
                <el-table-column align="center" prop="Address" label="处理状态"></el-table-column>
                <el-table-column align="center" prop="Address" label="处理完成时间"></el-table-column>
                <el-table-column align="center" prop="Address" label="操作者"></el-table-column>
				<el-table-column align="center" prop="Address" label="详情"></el-table-column>
			</el-table>
            <el-pagination
			background
			@current-change="handleCurrentChange"
			layout="total,prev, pager, next,jumper"
			:total="pageNum"
			:page-size="10">
			</el-pagination>
		</div>
	</div>
</template>

<script>
import {validateNumber} from '../utils/rules'
export default {
	data(){
		return {
			tableData: [],
			form:{

            },
			rules: {
        		factoryName:[
          			{ required: true, message: '请输入一个工厂名称', trigger: 'change' }
        		],
			},
			pageNum:0,
		}
	},
	methods: {
		close(){
			this.$refs['form'].resetFields()
		},
		restForm(){
			this.$nextTick(()=>{
				this.$refs['form'].resetFields()
			})
        },
        handleCurrentChange(){

        }
	}
}
</script>

<style scoped>
.title{
  text-align: left;
}
.btn{
	width: 500px;
	margin:10px 80px;
}
.el-input,.el-select{
	width:220px;
}
</style>


// WEBPACK FOOTER //
// src/pages/PackagingRelationFileQry.vue